import { NoDealsInfo } from './NoDealsInfo'

export default NoDealsInfo
